import { Component, OnInit } from "@angular/core";

interface MenuItem {
  _id: string;
  label: string;
  icon: string;
  url: string;
  submenus: MenuItem[];
}

type Menu = {
  category: string;
  menus: MenuItem[];
};

@Component({
  selector: "app-new-sidebar",
  templateUrl: "./new-sidebar.component.html",
  styleUrls: ["./new-sidebar.component.css"],
})
export class NewSidebarComponent implements OnInit {
  constructor() {}

  exponentIcon = "assets/img/exponent/exponent_logo_whilte.png";
  userMenu: Menu[] = [];
  enabledCategory = localStorage.getItem("default_category") ?? null;
  enabledMenu = localStorage.getItem("default_menu") ?? null;
  userType: string = localStorage.getItem("user_type") ?? null;

  ngOnInit(): void {
    this.generateSidebar();
  }

  removeSpaces(data: string) {
    return data.trim().toLowerCase().split(" ").join("-");
  }

  private generateSidebar = () => {
    if (!localStorage.getItem("user_menu")) {
      return;
    }

    this.userMenu = JSON.parse(localStorage.getItem("user_menu"));
  };
}
